function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#2CD589",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("circle", {
  fillOpacity: 0,
  stroke: "#2CD589",
  strokeWidth: 2,
  cx: 14,
  cy: 14,
  r: 13
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(3.500000, 3.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.281 7l-5.156 5.28-2.406-2.464L5 11.576 9.125 15.8 16 8.76z"
})));

var SvgPlusCircleChecked = function SvgPlusCircleChecked(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlusCircleChecked, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/PlusCircleChecked.68f91491.svg";
export { ForwardRef as ReactComponent };